import React from "react";
import PostFinanceIcon from '../../../assets/svg/postfinance.svg';
import FrameBlockResult from '../FrameBlockResult';
import { ApmsTypes } from "../../../constants";

const PostFinanceResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.PostFinance} icon={PostFinanceIcon} />
    )
}

export default PostFinanceResult;